import React, { FunctionComponent, useEffect, useState } from 'react';
import { RelatedEventsListProps, RelatedEventsListState } from './types';
import { Presentation } from './presentation';
import { getRelatedEvents } from '../../../services/events';

export const Component: FunctionComponent<RelatedEventsListProps> = (props) => {
  const [state, setState] = useState<RelatedEventsListState>({
    events: []
  });

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const result = await getRelatedEvents(props.eventId);
        setState({ events: result.events });
      } catch (error) {
        console.error('関連イベントの取得に失敗しました', error);
        setState({ events:[]});
      }
    };
    fetchEvents();
  }, [props.eventId]);

  return <Presentation events={state.events} />;
};
